import { render, staticRenderFns } from "./ListV2.vue?vue&type=template&id=a411d0ec&scoped=true"
import script from "./ListV2.vue?vue&type=script&lang=js"
export * from "./ListV2.vue?vue&type=script&lang=js"
import style0 from "./ListV2.vue?vue&type=style&index=0&id=a411d0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a411d0ec",
  null
  
)

export default component.exports